import React, { useEffect, useState } from "react";
import MobileLotInformation from "../children/MobileLotInformation";
import MobileBiddingArea from "../children/MobileBiddingArea";
import {
  calculateRemainingTime,
  convertTo12HourFormat,
  formatTime,
} from "../../../../../../helpers/helpers";
import TimeLeftIndicator from "../../children/TimeLeftIndicator";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getLivePaidEmdOffer } from "../../../../../../redux/action/liveRoom";

function MobileLotsDetail({ singleAuctionData, selectedLot }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { profile } = useSelector((state) => state?.profileStore);
  const [veryLessTimeStatus, setVeryLessTimeStatus] = useState(false);
  const [bidderDetails, setBidderDetails] = useState([]);
  const [endTimer, setEndTimer] = useState(false);
  const [startTimer, setStartTimer] = useState(true);
  const [remainingTime, setRemainingTime] = useState(
    calculateRemainingTime(
      singleAuctionData?.offers?.[selectedLot]?.offerSchedule?.endTimeAndDate
    )
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemainingTime = calculateRemainingTime(
        singleAuctionData?.offers?.[selectedLot]?.offerSchedule?.endTimeAndDate
      );
      setRemainingTime(newRemainingTime);
      if (formatTime(newRemainingTime) < "00:15:00") {
        setVeryLessTimeStatus(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [singleAuctionData, selectedLot]);

  useEffect(() => {
    const checkTimeRemaining = () => {
      const remaining = formatTime(
        calculateRemainingTime(
          singleAuctionData?.offers?.[selectedLot]?.offerSchedule
            ?.endTimeAndDate
        )
      );
      if (remaining <= "00:00:00") {
        setEndTimer(true);
      } else if (
        remaining === "00:00:05" ||
        remaining === "00:04:00" ||
        remaining === "00:02:00"
      ) {
        dispatch(getLivePaidEmdOffer(id, profile?.organization));
      } else {
        setEndTimer(false);
      }
    };

    const intervalId = setInterval(checkTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [singleAuctionData, dispatch, profile, id, selectedLot]);

  useEffect(() => {
    const checkTimeRemaining = () => {
      const startingTime = formatTime(
        calculateRemainingTime(
          singleAuctionData?.offers?.[selectedLot]?.offerSchedule
            ?.startTimeAndDate
        )
      );
      if (startingTime <= "00:00:00") {
        setStartTimer(false);
      } else {
        setStartTimer(true);
      }
    };

    const intervalId = setInterval(checkTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [singleAuctionData, dispatch, profile, id, selectedLot]);

  return (
    <div className="border-1px white" style={{ borderRadius: "8px" }}>
      <div
        className="valign-wrapper space-between"
        style={{ padding: "10px 14px" }}
      >
        <span className="small-text">
          Auction Id :{" "}
          <span className="cercle-purple-text">
            {singleAuctionData?.auction?.auctionId}
          </span>
        </span>
        {veryLessTimeStatus ? (
          <TimeLeftIndicator
            timeLeft={formatTime(remainingTime)}
            isMobileView={false}
          />
        ) : (
          <span className="small-text">
            Ends in{" "}
            <span className={`cercle-purple-text`}>
              {formatTime(remainingTime)}
            </span>
          </span>
        )}
      </div>
      <hr />
      <div className="flex">
        <MobileLotInformation
          offers={singleAuctionData?.offers?.[selectedLot]}
          bidderDetails={bidderDetails}
        />
        <MobileBiddingArea
          liveOfferData={singleAuctionData?.offers?.[selectedLot]}
          timeEnded={endTimer}
          startTimer={startTimer}
          setBidderDetails={setBidderDetails}
        />
      </div>
      <hr />
      <h6
        className="valign-wrapper justify-center p-1 font-15px margin-0px"
        style={{ backgroundColor: "#D9D9D933" }}
      >
        Product name :{" "}
        <span className="cercle-purple-text">
          {singleAuctionData?.offers?.[selectedLot]?.scrapDetails?.type}
        </span>
      </h6>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
          rowGap: "2px",
          columnGap: "10px",
          padding: "10px",
        }}
      >
        <h6>
          Min Bid(INR) :{" "}
          <span className="cercle-purple-text">
            {singleAuctionData?.offers?.[selectedLot]?.minimumBid}
          </span>
        </h6>
        <h6>
          QTY/UOM :{" "}
          <span className="cercle-purple-text">
            {singleAuctionData?.offers?.[selectedLot]?.scrapDetails?.quantity} /{" "}
            {singleAuctionData?.offers?.[selectedLot]?.scrapDetails?.unit}
          </span>
        </h6>
        <h6>
          EMD Amount :{" "}
          <span className="cercle-purple-text">
            {singleAuctionData?.offers?.[selectedLot]?.EMDAmount}
          </span>
        </h6>
        <h6>
          Lifting Period :{" "}
          <span className="cercle-purple-text">
            {singleAuctionData?.offers?.[selectedLot]?.liftingPeriod} days
          </span>
        </h6>
        <h6>
          Starting :{" "}
          <span className="cercle-purple-text">
            {" "}
            {convertTo12HourFormat(
              singleAuctionData?.offers?.[selectedLot]?.offerSchedule
                ?.startTimeAndDate
            )}
          </span>
        </h6>
        <h6>
          Closing :{" "}
          <span className="cercle-purple-text">
            {convertTo12HourFormat(
              singleAuctionData?.offers?.[selectedLot]?.offerSchedule
                ?.endTimeAndDate
            )}
          </span>
        </h6>
      </div>
    </div>
  );
}

export default MobileLotsDetail;
